import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo';
import type { GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorSocial } from './getTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorSocial';

/**
 * 트윗 작성자 정보
 */
export type GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthor = {
  /** 사용자 기본 정보 */
  basicInfo: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetTweets200PageAllOfThreeContentItemReferencedTweetTweetAuthorSocial;
};
